import React from 'react';
import { X, Check, ArrowRight } from 'lucide-react';
export function BeforeAfter() {
  const rows = [{
    before: 'Improvisabas el domingo a la noche',
    after: 'Abrís el tomo y la clase está lista'
  }, {
    before: 'Repetías las mismas 10 rutinas',
    after: 'Tenés 300+ clases con progresión real'
  }, {
    before: 'Buscabas videos en Instagram',
    after: 'Seguís un sistema de 52 semanas'
  }, {
    before: 'Grupo aburrido, cuotas que se caen',
    after: 'Grupo enganchado, turno lleno'
  }, {
    before: 'Daba lo mismo cada semana',
    after: 'Cada clase sorprende al grupo'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-10 md:mb-14" data-id="element-25">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-26">
            🔄 Antes vs. Después
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-27">
            No comprás solo PDFs.{' '}
            <span className="text-primary" data-id="element-28">
              Comprás orden para todo el año.
            </span>
          </h2>
        </div>

        {/* Two-column cards */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10" data-id="element-29">
          {/* BEFORE */}
          <div className="bg-surface border border-red-500/20 rounded-2xl p-6 md:p-7" data-id="element-30">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-red-500/20" data-id="element-31">
              <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center" data-id="element-32">
                <X className="w-5 h-5 text-red-400" data-id="element-33" />
              </div>
              <div data-id="element-34">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-red-400 font-bold" data-id="element-35">
                  Antes
                </p>
                <p className="text-base md:text-lg font-bold text-zinc-300" data-id="element-36">
                  Sin sistema
                </p>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-37">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-38">
                  <X className="w-4 h-4 text-red-500 shrink-0 mt-1" data-id="element-39" />
                  <span className="text-zinc-400 text-sm md:text-base" data-id="element-40">
                    {r.before}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="relative bg-surface border-2 border-primary rounded-2xl p-6 md:p-7 shadow-[0_0_30px_rgba(249,168,212,0.15)]" data-id="element-41">
            <div className="absolute -top-3 right-5 md:right-6 hidden md:flex bg-primary text-black font-bold px-3 py-0.5 rounded-full text-[10px] items-center gap-1" data-id="element-42">
              <ArrowRight className="w-3 h-3" data-id="element-43" /> CON HIIT PRO
            </div>
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-primary/20" data-id="element-44">
              <div className="w-10 h-10 rounded-xl bg-primary/15 border border-primary/30 flex items-center justify-center" data-id="element-45">
                <Check className="w-5 h-5 text-primary" data-id="element-46" />
              </div>
              <div data-id="element-47">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-primary font-bold" data-id="element-48">
                  Después
                </p>
                <p className="text-base md:text-lg font-bold text-white" data-id="element-49">
                  Con el Combo Completo HIIT Pro
                </p>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-50">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-51">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-1" data-id="element-52" />
                  <span className="text-white text-sm md:text-base font-medium" data-id="element-53">
                    {r.after}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Emotional close */}
        <div className="text-center" data-id="element-54">
          <p className="text-base md:text-2xl text-zinc-200 font-bold leading-relaxed max-w-3xl mx-auto" data-id="element-55">
            Recuperás{' '}
            <span className="text-primary" data-id="element-56">tiempo, claridad mental</span> y{' '}
            <span className="text-primary" data-id="element-57">turnos llenos.</span>
          </p>
        </div>
      </div>
    </section>;
}